module.exports = __webpack_public_path__ + "img/iconvms.a259c87e.svg";